<template>
  <div class="">
    <validation-observer
      :ref="resultProviderContactFormRef"
      v-slot="{}"
      tag="form"
    >
      <div class="row mt-3">
        <div class="col col-sm col-12 pt-2">
          <em class="fas fa-info-circle text-orange mr-1" />
          <span class="color-gray-7 font-16 font-weight-bold">
            Información de Usuario
          </span>
          <div class="summary-container">
            <span class="dot text-center">
              <i class="user-log-icon fas fa-id-card-alt" />
            </span>
            <span class="field-label d-inline-block user-log-label">
              Ultimo Acceso:
            </span>
            <span class="bold">
              {{ lastAccessDateFormated || 'No Disponible' }}
            </span>

            <div class="d-inline-block user-log-divider" />

            <span class="field-label d-inline-block user-log-label">
              Aprobación:
            </span>
            <i
              class="user-log-icon fas"
              :class="[
                contact.user.isApproved
                  ? 'fa-check color-green'
                  : 'fa-clock color-yellow',
              ]"
              style="margin-right:8px;"
            />
            <span class="bold">
              {{ contact.user.isApproved ? 'Aprobada' : 'Pendiente' }}
            </span>

            <div class="d-inline-block user-log-divider" />

            <span class="field-label d-inline-block user-log-label">
              Bloqueo:
            </span>
            <i
              class="user-log-icon fas"
              :class="[
                contact.user.isLockedOut
                  ? 'fa-lock color-red'
                  : 'fa-lock-open color-green',
              ]"
              style="margin-right:8px;"
            />
            <span class="bold">
              {{ contact.user.isLockedOut ? 'Bloqueado' : 'Desbloqueado' }}
            </span>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="color-gray-6 font-14">Usuario:</div>
              <div class="color-black font-16">
                <span class="bold">{{ contact.user.userName | empty }}</span>
              </div>
            </div>
            <div class="col-3">
              <div class="color-gray-6 font-14">Autenticación:</div>
              <div class="color-black font-16">
                <span class="bold">
                  {{ contact.user.authenticationMode | empty }}
                </span>
              </div>
            </div>
            <div class="col-4" />
            <div
              class="col-2"
              :class="[
                contact.user.activeFlag ? 'statusActive' : 'statusInctive',
              ]"
            >
              <i
                class="user-log-icon fas"
                :class="[
                  contact.user.activeFlag
                    ? 'fa-check-circle color-green'
                    : 'fa-minus-circle color-gray',
                ]"
                style="margin-right:8px;"
              />
              <span class="bold">
                {{ contact.user.status | empty }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row py-3 mr-md-0" />
    </validation-observer>
  </div>
</template>

<script>
//constants
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import moment from 'moment';

export default {
  name: 'ContractAdditionalInformation',
  components: {},
  props: {
    contact: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {},
    };
  },
  mounted() {},
  mixins: [alertMixin],
  computed: {
    lastAccessDateFormated() {
      return this.contact.user.lastAccessDate
        ? moment(this.contact.user.lastAccessDate)
            .locale('es-PR')
            .format('D/MMM/YYYY - H:mm a')
        : '';
    },
  },
  methods: {},
};
</script>

<style scoped>
.summary-container {
  background-color: #f7f7f7;
  padding: 4px;
  margin-bottom: 10px;
}

.user-log-icon {
  font-size: 1rem;
  color: #fff;
}

.color-green {
  color: #a3e4b1;
}

.color-yellow {
  color: #ffcd71;
}

.user-log-label {
  margin: 0 10px 0 10px;
}

.user-log-divider {
  vertical-align: middle;
  height: 29px;
  border-right: 1px solid #e2e2e2;
  margin: 0 6px 0 16px;
}

.dot {
  background-color: #2db782;
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: #fff;
  display: inline-block;
}
.bold {
  font-weight: bold;
}
.statusActive {
  padding: 12px 20px 12px 20px !important;
  gap: 10px !important;
  border-radius: 20px 20px 20px 20px !important;
  border: 1px solid #2db782 !important;
  background: #ebfaf2 !important;
  font-family: Lato !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 19.2px !important;
  text-align: left !important;
  color: #2db782 !important;
  max-width: 15.666667% !important;
  text-align: center !important;
}

.statusInctive {
  padding: 12px 20px 12px 20px !important;
  gap: 10px !important;
  border-radius: 20px 20px 20px 20px !important;
  border: 1px solid #b5c3bc !important;
  background: #f7f7f7 !important;
  font-family: Lato !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 19.2px !important;
  text-align: left !important;
  color: #aab7b1 !important;
  max-width: 15.666667% !important;
  text-align: center !important;
}
</style>
